import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';

function AdditionalInformationModal({ data, isModalOpen, setIsModalOpen }) {
  const [parsedData, setParsedData] = useState();
  const [renderType, setRenderType] = useState();

  useEffect(() => {
    try {
      const parsed = JSON.parse(data);
      if (typeof parsed === 'object') {
        setParsedData(parsed);
        setRenderType('object');
      } else {
        setParsedData(parsed);
        setRenderType('other');
      }
    } catch (error) {
      console.error('Error parsing JSON data:', error);
    }
  }, [data]);

  const renderContent = () => {
    if (renderType === 'object') {
      return (
        <pre>
          {Object.entries(parsedData).map(([key, value]) => (
            <div key={key}>
              {key}: {JSON.stringify(value, null, 2)}
            </div>
          ))}
        </pre>
      );
    } else {
      return (
        <div>
          {parsedData !== undefined && parsedData !== ''
            ? JSON.stringify(parsedData)
            : data}
        </div>
      );
    }
  };

  return (
    <Modal
      title="Additional Information"
      visible={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}>
      {renderContent()}
    </Modal>
  );
}

export default AdditionalInformationModal;
